import { useState, useEffect, useMemo } from "react";
import { bool, arrayOf, string, func } from "prop-types";
import { MAX_WORK_TYPE_LENGTH } from "@repo/utils";
import { simplifyTextString } from "@utils";
import { TextClearInput } from "@components";
import { useTranslation } from "react-i18next";

export const RateNameInput = ({
  value,
  autoFocus,
  onAccept,
  placeholder,
  usedElementNames,
  showWorkTypeAlert,
}) => {
  const { t } = useTranslation();
  
  const [ focused, setFocused ] = useState(autoFocus);
  const [ newName, setNewName ] = useState(value || "");
  const [ valueIsUsed, setUsedValue ] = useState(false);
  
  useEffect(() => {
    setNewName(value || "");
  }, [ value ]);
  
  const messageTitle = useMemo(() => {
    if(showWorkTypeAlert)
      return t("views.settings.projects.rate_card.edit_alert")
  }, []);
  
  const handleNameChange = (newName) => {
    setNewName(newName);
    setUsedValue(Boolean(
      usedElementNames.find(({ name }) => simplifyTextString(name) === simplifyTextString(newName))
    ));
  }
  
  const handleAccept = () => {
    onAccept(newName);
    setFocused(false);
  }
  
  return (
    <TextClearInput
      multiline
      onChange={handleNameChange}
      onAccept={handleAccept}
      onFocus={() => setFocused(true)}
      maxLength={MAX_WORK_TYPE_LENGTH}
      value={newName}
      focused={focused}
      placeholder={placeholder}
      acceptOnClickAway
      confirmOnEnter
      error={valueIsUsed}
      clickDialogMessageTitle={messageTitle}
    />
  )
}

RateNameInput.propTypes = {
  value: string,
  onAccept: func.isRequired,
  placeholder: string.isRequired,
  usedElementNames: arrayOf(string).isRequired,
  autoFocus: bool,
  showWorkTypeAlert: bool,
}